import React, { useState, useEffect, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';
import Select, { components } from 'react-select';
import axios from "axios";

import { country_arr } from "../includes/common_arr/countries-arr.js";
import { s_a } from "../includes/common_arr/states-arr.js";
import { useTheme } from "../includes/theme-provider.js"
import { useModal } from '../providers/modal-provider.js';
import { useAuthData } from '../includes/auth-provider.js';
import { getGstinSearchDetails } from "./generalUtils.js";
import { getCookie } from './cookie.js';


// modalData must have these attributes
// modalData = {
// 		apiCallback: function | undefined,
// 		entityType: string | undefined,
// 		entityId: string | undefined,
//		page_name: string,
// }
export default function GstInModal() {
    const { theme, dropdownStyleDark } = useTheme()

    const { displayModal, modalData, closeModal, setModalData, setModalView } = useModal()

    const [gstinSearchDetails, setGstinSearchDetails] = useState(null)
    const [gstinSearchDetailsApiState, setGstinSearchDetailsApiState] = useState(false)

    // const [gstinId, setGstinId] = useState(""); // only to be used in case of edit
    const [gstinTreatment, setGstinTreatment] = useState(null)
    const [gstinNumber, setGstinNumber] = useState("");
    const [gstinLegalName, setGstinLegalName] = useState("");
    const [gstinTradeName, setGstinTradeName] = useState("");
    const [gstinSelectedPlaceOfSupply, setGstinSelectedPlaceOfSupply] = useState(null)

    const [gstinSubmitButtonState, setGstinSubmitButtonState] = useState(false);

    const { write, user, organization_id } = useAuthData(modalData.page_name)

    const gstinTreatmentList = [
        { label: "Registered Business-Regular", value: "Registered Business-Regular", description: "A business that is registered under GST" },
        { label: "Registered Business-Composition", value: "Registered Business-Composition", description: "A business that is registered under composition scheme in GST" },
        { label: "Special Economic Zone", value: "Special Economic Zone", description: "Business that is located in a special economic zone" },
        { label: "Deeemed Export", value: "Deeemed Export", description: "Supply of goods to an export oriented unit" },
        { label: "SEZ Devloper", value: "SEZ Devloper", description: "An organization/person who owns atleast 26% of the equity in creating business units" }
    ]

    const supplyStateOptions = useMemo(() => {
        let state_arr = s_a[country_arr.findIndex((obj) => obj == "India")].split("|");
        let obj_array = [];
        for (let i = 0; i < state_arr.length; i++) {
            obj_array.push({ value: state_arr[i], label: state_arr[i] });
        }
        return obj_array;
    }, [s_a])

    // useEffect(() => {
    //     if (modalData && modalData.updateMode && modalData.currencyData) {
    //         setSelectedCurrencyCode({ label: modalData.currencyData.currency_code, value: modalData.currencyData.currency_code })
    //         setCurrencySymbol(modalData.currencyData.currency_symbol)
    //         setSelectedCurrencyDecimalPlace({ label: modalData.currencyData.decimal_place, value: modalData.currencyData.decimal_place })
    //         setSelectedCurrencyFormat({ label: modalData.currencyData.format, value: modalData.currencyData.format })
    //     }
    // }, [modalData])

    const gstinSubmitValidation = () => {
        if (!gstinTreatment) {
            swal("Warning!", "GST Treatment cannot be empty", "warning");
            return false
        }
        if (!gstinNumber) {
            swal("Warning!", "GSTIN cannot be empty", "warning");
            return false
        }
        if (!gstinLegalName) {
            swal("Warning!", "Business Legal Name cannot be empty", "warning");
            return false
        }
        if (!gstinSelectedPlaceOfSupply) {
            swal("Warning!", "Place of Supply cannot be empty", "warning");
            return false
        }
        return true
    }

    const newGstInSubmit = () => {
        let object = {};

        object.GstIn = gstinNumber;

        if (modalData.entityType === "CUSTOMER") {
            object.customer_id = modalData.entityId
        }
        else if (modalData.entityType === "VENDOR") {
            object.vendor_id = modalData.entityId
        }
        else if (modalData.entityType === "MANUFACTURER") {
            object.manufacturer_id = modalData.entityId
        }

        object.gstTreatment = gstinTreatment.value;
        object.place_of_supply = gstinSelectedPlaceOfSupply.value;
        object.legal_name = gstinLegalName;
        object.trade_name = gstinTradeName;

        object.id = "";  // empty string incase of add, gstin id incase of edit

        object.organization_id = organization_id;
        object.page_name = modalData.page_name;

        // console.log(object)
        setGstinSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        let url
        if (modalData.entityType === "CUSTOMER") {
            url = "save-customer-tax-details"
        }
        else if (modalData.entityType === "VENDOR") {
            url = "save-vendor-tax-details"
        }
        else if (modalData.entityType === "MANUFACTURER") {
            url = "save-manufacturer-tax-details"
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/${url}`, object, headers).then((res) => {
            setGstinSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Gstin details added successfully!", "success");

                modalData.apiCallback?.()
                handleGstModalClose()
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleGstModalClose = () => {
        setGstinSearchDetails(null)
        setGstinSearchDetailsApiState(false)
        // setGstinId("");
        setGstinTreatment(null)
        setGstinNumber("");
        setGstinLegalName("");
        setGstinTradeName("");
        setGstinSelectedPlaceOfSupply(null)

        closeModal()
        setModalView(null)
        setModalData(null)
    }

    return (
        <Modal show={displayModal} onHide={() => { handleGstModalClose() }} size="lg" centered>
            <Modal.Header className='py-2'>
                <Modal.Title>Add GSTIN Details</Modal.Title>
                <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleGstModalClose() }}>
                    <span className="svg-icon svg-icon-1">
                        <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                            </g>
                        </svg>
                    </span>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <div className="d-flex flex-wrap gap-5 mb-2">
                        <div className="fv-row w-100 flex-md-root">
                            <label className="required fw-bold form-label">GST Treatment</label>
                            <Select
                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                options={gstinTreatmentList}
                                value={gstinTreatment}
                                onChange={(val) => { setGstinTreatment(val) }}
                                components={{
                                    Option: (props) => {
                                        return (
                                            <components.Option  {...props}>
                                                {props.children}
                                                <span className="fw-semibold text-gray-400 d-block fs-8">{props.data.description}</span>
                                            </components.Option >
                                        )
                                    }
                                }}
                            />
                        </div>
                    </div>


                    <div className="row mb-5">
                        <div className="col-md-12">
                            <label className="required fs-5 fw-bold mb-2">GSTIN</label>
                            <div className="gap-2 d-flex">
                                <input id="GSTIN" type="text" className="form-control" placeholder="Enter GST number" name="GSTIN" value={gstinNumber} onChange={(e) => { setGstinNumber(e.target.value); setGstinSearchDetails(null); }} />
                                <button className="btn btn-sm btn-secondary" disabled={gstinSearchDetailsApiState}
                                    onClick={async () => {
                                        const gstinRegex = /^[0-9A-Za-z]{15}$/;
                                        if (!gstinRegex.test(gstinNumber)) {
                                            swal("Warning!", "Invalid GSTIN format", "warning");
                                            return;
                                        }

                                        setGstinSearchDetailsApiState(true)

                                        const res = await getGstinSearchDetails(gstinNumber, organization_id, modalData.page_name, user.email);
                                        if (res) {
                                            setGstinSearchDetails(res)

                                            setGstinLegalName(res.lgnm)
                                            setGstinTradeName(res.tradeNam)
                                            setGstinSelectedPlaceOfSupply({ label: res.pradr.addr.stcd, value: res.pradr.addr.stcd })
                                        }

                                        setGstinSearchDetailsApiState(false)
                                    }}
                                >
                                    {
                                        gstinSearchDetailsApiState === true ?
                                            <span className="spinner-border spinner-border-sm align-middle"></span>
                                            :
                                            gstinSearchDetails === null ?
                                                <span className="text-dark">Verify</span> :
                                                <i className="bi bi-patch-check-fill text-success fs-2 p-0"></i>
                                    }
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className="col-md-4">
                            <label className="required fs-5 fw-bold mb-2">Business Legal Name</label>
                            <input id="Business_Legal_Name" type="text" className="form-control mb-2" placeholder="Legal Name" name="Business_Legal_Name" value={gstinLegalName} onChange={(e) => { setGstinLegalName(e.target.value) }} />
                        </div>
                        <div className="col-md-4">
                            <label className="fs-5 mb-2">Business Trade Name</label>
                            <input id="Business_Trade_Name" type="text" className="form-control mb-2" placeholder="Trade Name" name="Business_Trade_Name" value={gstinTradeName} onChange={(e) => { setGstinTradeName(e.target.value) }} />
                        </div>
                        <div className="col-md-4">
                            <label className="required fw-bold form-label">Place Of Supply</label>
                            <Select
                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                options={supplyStateOptions}
                                onChange={(val) => { setGstinSelectedPlaceOfSupply(val) }}
                                value={gstinSelectedPlaceOfSupply}
                                isClearable
                            />
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-danger rounded" onClick={() => { handleGstModalClose() }}>Close</button>
                {
                    write &&
                    <button
                        className="btn btn-info rounded"
                        data-kt-indicator={gstinSubmitButtonState ? "on" : "off"}
                        disabled={gstinSubmitButtonState}
                        onClick={() => { gstinSubmitValidation() && newGstInSubmit() }}
                    >
                        <span className="indicator-label">Save</span>
                        <span className="indicator-progress">Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    </button>
                }
            </Modal.Footer>
        </Modal >
    );
};
